import React from 'react';
import { View, StyleSheet, TouchableOpacity, Linking } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../theme/ThemeContext';
import ThemedText from '../common/ThemedText';

const TodoAppPromo: React.FC = () => {
  const { theme } = useTheme();

  const handlePress = async () => {
    const url = 'https://play.google.com/store/apps/details?id=com.lifenote.ln';
    try {
      const supported = await Linking.canOpenURL(url);
      if (supported) {
        await Linking.openURL(url);
      } else {
        console.error("Can't open URL:", url);
      }
    } catch (error) {
      console.error('Error opening ToDo app link:', error);
    }
  };

  return (
    <TouchableOpacity 
      style={[styles.container, { backgroundColor: theme.accent + '15', borderColor: theme.accent + '30' }]}
      onPress={handlePress}
      activeOpacity={0.8}
    >
      <View style={[styles.iconContainer, { backgroundColor: theme.accent }]}>
        <Ionicons name="checkmark-done-outline" size={18} color="#FFFFFF" />
      </View>
      <ThemedText style={[styles.text, { color: theme.text }]}>
        ToDo
      </ThemedText>
      <Ionicons name="arrow-forward" size={16} color={theme.accent} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    marginBottom: 16,
    borderWidth: 1,
  },
  iconContainer: {
    width: 32,
    height: 32,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  text: {
    fontSize: 14,
    fontWeight: '600',
    flex: 1,
  },
});

export default TodoAppPromo;
